var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H14.2C15.8802 0.5 16.7202 0.5 17.362 0.826981C17.9265 1.1146 18.3854 1.57354 18.673 2.13803C19 2.77976 19 3.61984 19 5.3V13.7C19 15.3802 19 16.2202 18.673 16.862C18.3854 17.4265 17.9265 17.8854 17.362 18.173C16.7202 18.5 15.8802 18.5 14.2 18.5H13M8 4.5L13 9.5M13 9.5L8 14.5M13 9.5H1",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/LoginIcon.9d0f3f7f0808c8be5f55101a60272e08.svg";
export { ForwardRef as ReactComponent };